import { observer } from "mobx-react-lite";
import LoadingIndicator from "../../../components/loadingIndicator/LoadingIndicator";
import { useMatchDetailsStore } from "../../../stores/StoreContext";
import { CustomDialog } from "../../../components/modal/dialog/CustomDialog";

export const MatchStatsLoader = observer(() => {
  const matchDetailsStore = useMatchDetailsStore();
  return (
    <>
      <CustomDialog
        visible={matchDetailsStore.modalData?.visible ?? false}
        title={matchDetailsStore.modalData?.title ?? ""}
        description={matchDetailsStore.modalData?.children ?? ""}
        onCancel={matchDetailsStore.modalData?.onClose}
        onConfirm={matchDetailsStore.modalData?.onAccept}
      />
      <LoadingIndicator loading={matchDetailsStore.loading} />
    </>
  );
});
